export default "__VITE_ASSET__5oxfv5UO__"